/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type RegisterForEventQuery = {
    readonly _children: {
        readonly items: ReadonlyArray<{
            readonly title?: string;
            readonly metaTitle?: string | null;
            readonly formType?: string;
            readonly content?: string | null;
            readonly nameLabel?: string | null;
            readonly surnameLabel?: string | null;
            readonly emailLabel?: string | null;
            readonly registrationCityLabel?: string | null;
            readonly citySubfieldLabel?: string | null;
            readonly privacyPolicyLabelText?: string | null;
            readonly registrationSkillsLabel?: string | null;
            readonly registrationLevelLabel?: string | null;
            readonly registrationNewslettersAgreementLabel?: string | null;
            readonly registrationPossibleCooperationAgreementLabel?: string | null;
            readonly submitButtonLabel?: string | null;
            readonly cityPlaceholder?: string | null;
            readonly registrationLevelPlaceholder?: string | null;
            readonly registrationSkillsValues?: ReadonlyArray<string | null> | null;
            readonly registrationLevelValues?: ReadonlyArray<string | null> | null;
        } | null> | null;
    } | null;
    readonly " $refType": "RegisterForEventQuery";
};
export type RegisterForEventQuery$data = RegisterForEventQuery;
export type RegisterForEventQuery$key = {
    readonly " $data"?: RegisterForEventQuery$data;
    readonly " $fragmentRefs": FragmentRefs<"RegisterForEventQuery">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RegisterForEventQuery",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PublishedContentConnection",
      "kind": "LinkedField",
      "name": "_children",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "items",
          "plural": true,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "title",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "metaTitle",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "formType",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "content",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "nameLabel",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "surnameLabel",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "emailLabel",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "registrationCityLabel",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "citySubfieldLabel",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "privacyPolicyLabelText",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "registrationSkillsLabel",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "registrationLevelLabel",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "registrationNewslettersAgreementLabel",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "registrationPossibleCooperationAgreementLabel",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "submitButtonLabel",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cityPlaceholder",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "registrationLevelPlaceholder",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "registrationSkillsValues",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "registrationLevelValues",
                  "storageKey": null
                }
              ],
              "type": "FormPagePublishedContent",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "HomePublishedContent",
  "abstractKey": null
};
(node as any).hash = '4a247b1770b4b54ef481f96b151a5fbf';
export default node;
